/* Outdoors Nordic. Flyttad ur sections/on-funnel-frame.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */
(function () {
var host = document.currentScript && document.currentScript.previousElementSibling;
while (host && (!host.classList || !host.classList.contains('on-ff'))) { host = host.previousElementSibling; }
if (!host) host = document.querySelector('.on-ff');
if (!host) return;
/* Footern flyttas till sidans slut så den hamnar i botten oavsett var sektionen ligger */
/* Markera att besokaren ar inne i ett funnel-flode. Laser av i on-design-tokens
(i <head>, fore paint) pa produktsidan, som da skalar ner headern. */
try { sessionStorage.setItem('onFunnel', '1'); } catch (e) {}
/* Produktlankar fran funneln ska landa i funnel-produktvyn: bara landsvaljare,
varukorg och sjalva produktsidan. Liquid kan inte lasa query-parametrar, sa vi
later ?view=funnel valja mallen product.funnel i stallet. */
document.querySelectorAll('a[href*="/products/"]').forEach(function(a){
try {
 var u = new URL(a.getAttribute('href'), window.location.origin);
 if (u.pathname.indexOf('/products/') === -1) return;
 if (u.searchParams.get('view')) return;
 u.searchParams.set('view', 'funnel');
 a.setAttribute('href', u.pathname + u.search + u.hash);
} catch (e) {}
});
/* STICKY-FALLA: <main class="content-for-layout"> har overflow-x: clip (vart eget
skydd mot horisontell scroll). En klippande forfader dodar position: sticky, sa
baren scrollade ivag aven med instalningen pa. Vi flyttar hela ramen till
<body> - samma grepp som footern nedan - da finns ingen klippande forfader kvar. */
if (host.parentElement !== document.body) {
document.body.insertBefore(host, document.body.firstChild);
}
var foot = host.querySelector('.on-ff__foot');
if (foot && foot.parentElement === host) {
var main = document.getElementById('MainContent') || document.body;
main.appendChild(foot);
}
/* Bredd-variablerna maste sattas pa <html>: innehallet ar syskon till ramen. */
var cmax = host.getAttribute('data-cmax'), cpad = host.getAttribute('data-cpad');
if (cmax) document.documentElement.style.setProperty('--on-ff-cmax', cmax + 'px');
if (cpad) document.documentElement.style.setProperty('--on-ff-cpad', cpad + 'px');
/* Progressbar: andel av sidan som scrollats */
var bar = host.querySelector('[data-ff-progress]');
if (bar && host.getAttribute('data-progress') === '1') {
var ticking = false;
function upd() {
 ticking = false;
 var h = document.documentElement;
 var max = (h.scrollHeight - h.clientHeight) || 1;
 var pct = Math.min(100, Math.max(0, (h.scrollTop || window.pageYOffset) / max * 100));
 bar.style.width = pct.toFixed(1) + '%';
}
window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
window.addEventListener('resize', upd, { passive: true });
upd();
}
/* Håll varukorgs-räknaren aktuell (funnel-header har ingen native cart-bubble) */
var count = host.querySelector('[data-ff-cart-count]');
if (count) {
document.addEventListener('cart:update', function (e) {
 try {
   var n = e && e.detail && e.detail.data && e.detail.data.item_count;
   if (typeof n === 'number') count.textContent = n;
 } catch (err) {}
});
}
  })();

